import React, { useEffect, useMemo, useState } from "react";
// import fetchData from "../api/fetchApi";
// import { getLang, t } from "../i18n";

export default function DashboardHome() {
  // RTL support
  const dir = "rtl";

  // Local demo state (replace with real fetch later)
  const [metrics] = useState([
    { title: "عدد المشتركين", value: 100, delta: +8.9 },
    { title: "عدد القوانين", value: 487, delta: -1.4 },
    { title: "عدد الأحكام", value: 2408, delta: +4.6 },
    { title: "عدد القرارات", value: 5000, delta: +12.3 },
  ]);

  const lineMonths = [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
  ];
  const lineValues = [12, 18, 20, 17, 19, 22, 21, 23, 20, 19, 24]; // آلاف

  // Build full chart geometry for the subscribers line chart
  const chart = useMemo(() => {
    const viewW = 700,
      viewH = 260;
    const padLeft = 20,
      padRight = 60,
      padTop = 24,
      padBottom = 36; // leave room for right axis + months
    const w = viewW - padLeft - padRight;
    const h = viewH - padTop - padBottom;
    const n = Math.max(lineValues.length - 1, 1);
    const maxV = Math.max(...lineValues, 25);
    const minV = Math.min(...lineValues, 10);
    const sx = (i) => padLeft + w * (i / n);
    const sy = (v) => padTop + h * (1 - (v - minV) / (maxV - minV + 1e-4));

    const points = lineValues.map((v, i) => [sx(i), sy(v)]);
    const path = points
      .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x},${y}`)
      .join(" ");

    const baselineY = sy(minV);
    const area =
      `M ${points[0][0]} ${points[0][1]} ` +
      points
        .slice(1)
        .map(([x, y]) => `L ${x} ${y}`)
        .join(" ") +
      ` L ${points[points.length - 1][0]} ${baselineY} L ${points[0][0]} ${baselineY} Z`;

    const yTicks = [10, 15, 20, 25];
    const tickYs = yTicks.map(sy);

    return {
      viewW,
      viewH,
      padLeft,
      padRight,
      padTop,
      padBottom,
      w,
      h,
      n,
      maxV,
      minV,
      sx,
      sy,
      points,
      path,
      area,
      baselineY,
      yTicks,
      tickYs,
    };
  }, [lineValues]);

  // Default selected point in the middle; update on hover
  const [hoverIndex, setHoverIndex] = useState(5);

  // Gauge data
  const gauge = {
    total: 807,
    // Order for arcs (left to right on the semicircle): القوانين (blue), تحديثات (amber), الاستشارات (green)
    parts: [
      { label: "القوانين", value: 321, color: "#2563eb" },
      { label: "تحديثات", value: 200, color: "#f59e0b" },
      { label: "الاستشارات", value: 142, color: "#16a34a" },
    ],
  };

  // Build gauge arcs (semi-circle) with small gaps and rounded ends
  const gaugeArcs = useMemo(() => {
    const cx = 180,
      cy = 180,
      r = 140; // semi circle
    const sum = gauge.parts.reduce((a, p) => a + p.value, 0) || 1;
    const gap = 0.15; // radians gap between segments
    let acc = Math.PI; // start at 180deg
    const toXY = (ang) => [cx + r * Math.cos(ang), cy + r * Math.sin(ang)];
    return gauge.parts.map((p) => {
      const span = Math.PI * (p.value / sum);
      const trimmed = Math.max(span - gap, 0.001);
      const start = acc + (span - trimmed) / 2; // center the gap
      const end = start + trimmed;
      acc = acc + span;
      const [x1, y1] = toXY(start);
      const [x2, y2] = toXY(end);
      const largeArc = trimmed > Math.PI ? 1 : 0;
      const d = `M ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2}`;
      return { d, color: p.color, label: p.label, value: p.value };
    });
  }, [gauge.parts]);

  const partsSum = useMemo(
    () => gauge.parts.reduce((a, p) => a + p.value, 0) || 1,
    [gauge.parts]
  );
  // Legend order to match the screenshot layout (from right to left): القوانين, تحديثات, الاستشارات
  const legendParts = [gauge.parts[2], gauge.parts[1], gauge.parts[0]];

  const subscribers = [
    {
      name: "سراج صالح",
      dept: "مصر",
      phone1: "(818) 472-3905",
      phone2: "23124324023",
      status: "فعال",
    },
    {
      name: "طارق خطابي",
      dept: "مصر",
      phone1: "(818) 472-3905",
      phone2: "23124324023",
      status: "فعال",
    },
    {
      name: "أشرف حسن",
      dept: "مصر",
      phone1: "(818) 472-3905",
      phone2: "23124324023",
      status: "فعال",
    },
    {
      name: "عبدالمحسن سلار",
      dept: "مصر",
      phone1: "(818) 472-3905",
      phone2: "23124324023",
      status: "فعال",
    },
    {
      name: "أحمد محمد",
      dept: "مصر",
      phone1: "(818) 472-3905",
      phone2: "23124324023",
      status: "انتهى الاشتراك",
    },
    {
      name: "يوسف داود",
      dept: "مصر",
      phone1: "(818) 472-3905",
      phone2: "23124324023",
      status: "فعال",
    },
  ];

  useEffect(() => {
    // Fetch real data here if needed later
  }, []);

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir={dir}>
      {/* Header */}
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h1 className="text-base md:text-lg font-bold text-[#1D2035]">
          لوحة التحكم
        </h1>
        <button className="flex items-center gap-2 rounded-lg px-4 py-2 text-white bg-[var(--Primary-Primary)] shadow-sm">
          إضافة قانون جديد
          <span className="text-lg leading-none">+</span>
        </button>
      </div>

      {/* KPI cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {metrics.map((m, i) => (
          <div
            key={i}
            className="bg-[#F3F4F4] rounded-xl border border-gray-100 shadow-sm p-1"
          >
            <div className=" bg-white h-5/6 rounded-xl p-3">
              <div className="flex items-center justify-between mb-3 ">
                <span className="text-[13px] text-gray-500">{m.title}</span>
              </div>
              <div className="text-2xl font-extrabold text-[#1D2035] mb-3">
                {m.value.toLocaleString()}
              </div>
            </div>

            <div className="text-[12px] flex justify-between gap-2 m-1 p-1">
              <span className="text-black">مقارنة بالشهر الماضي</span>
              <span
                className={`${
                  m.delta >= 0 ? "text-green-600" : "text-red-600"
                }`}
              >
                {m.delta >= 0 ? `% ${m.delta} ` : `% ${m.delta} `}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Charts row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mt-4 md:mt-6">
        {/* Gauge card */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 md:p-6">
          <div
            className="border-b flex w-full border-gray-100"
          >
            <h3 className="font-semibold text-[#1D2035] mb-2 ">معدل القوانين</h3>
          </div>
         
          <div className="flex items-center justify-center">
            <svg viewBox="0 0 360 200" className="w-full h-48">
              <path
                d="M 40 180 A 140 140 0 0 1 320 180"
              
                strokeWidth="24"
                fill="none"
                strokeLinecap="round"
              />
              {gaugeArcs.map((a, idx) => (
                <path
                  key={idx}
                  d={a.d}
                  stroke={a.color}
                  strokeWidth="24"
                 
                  fill="none"
                 
                />
              ))}
              {/* Center label above value to match the design */}
              <text
                x="180"
                y="170"
                textAnchor="middle"
                className="fill-gray-400 "
                fontSize="14"
              >
                إجمالي القوانين
              </text>
              <text
                x="180"
                y="140"
                textAnchor="middle"
                className="fill-[#1D2035]"
                fontSize="44"
                fontWeight="700"
              >
                {gauge.total}
              </text>
            </svg>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-3 text-xs">
            {legendParts.map((p, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-gray-200 shadow-sm p-3 md:p-4 text-center"
              >
                <div className="flex items-center justify-center gap-1 mb-2 text-sm text-[#1D2035]">
                  <span
                    className="inline-block w-2.5 h-2.5 rounded-full"
                    style={{ background: p.color }}
                  />
                  {p.label}
                </div>
                <div className="text-2xl font-semibold text-[#1D2035]">
                  {p.value}
                </div>
                <div className="text-gray-500 mt-1">
                  {Math.round((p.value / partsSum) * 100)}%
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Line chart card (spans 2) */}
        <div className="lg:col-span-2 bg-white rounded-xl border border-gray-100 shadow-sm p-4 md:p-6">
          <div className="flex items-center justify-between pb-3 border-b border-gray-100">
            <h3 className="font-semibold text-[#1D2035]">معدل المشتركين</h3>
           
          </div>
          {/* small legend under top border */}
          <div className="flex items-center justify-end gap-2 text-[13px] text-[#1D2035] mt-3 mb-1">
            <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ background: "#dc2626" }} />
            إجمالي المشتركين
          </div>
          <div className="w-full">
            <svg
              viewBox={`0 0 ${chart.viewW} ${chart.viewH}`}
              className="w-full h-56"
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = ((e.clientX - rect.left) / rect.width) * chart.viewW;
                let idx = 0,
                  d = Infinity;
                chart.points.forEach(([px], i) => {
                  const dist = Math.abs(px - x);
                  if (dist < d) {
                    d = dist;
                    idx = i;
                  }
                });
                setHoverIndex(idx);
              }}
              onMouseLeave={() => setHoverIndex(5)}
            >
              <defs>
                <linearGradient id="subscribersFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#dc2626" stopOpacity="0.14" />
                  <stop offset="100%" stopColor="#dc2626" stopOpacity="0.04" />
                </linearGradient>
              </defs>

              {/* horizontal grid lines */}
              {chart.tickYs.map((y, i) => (
                <line
                  key={i}
                  x1={chart.padLeft}
                  y1={y}
                  x2={chart.viewW - chart.padRight}
                  y2={y}
                  stroke="#e5e7eb"
                  strokeDasharray="4 4"
                />
              ))}

              {/* area fill under the line */}
              <path d={chart.area} fill="url(#subscribersFill)" />

              {/* main line */}
              <path
                d={chart.path}
                fill="none"
                stroke="#dc2626"
                strokeWidth="2.5"
              />

              {/* points */}
              {chart.points.map(([x, y], i) => (
                <circle key={i} cx={x} cy={y} r="3" fill="#dc2626" />
              ))}

              {/* right Y axis labels */}
              {chart.tickYs.map((y, i) => (
                <text
                  key={`t-${i}`}
                  x={chart.viewW - chart.padRight + 8}
                  y={y + 4}
                  className="fill-gray-400"
                  fontSize="12"
                >
                  {`ألف ${chart.yTicks[i]}`}
                </text>
              ))}

              {/* selected/hover vertical line and tooltip */}
              {(() => {
                const idx = Math.min(
                  Math.max(hoverIndex ?? 5, 0),
                  chart.points.length - 1
                );
                const [sx, sy] = chart.points[idx];
                const bx = Math.min(
                  Math.max(sx - 90, 8),
                  chart.viewW - chart.padRight - 180
                );
                const by = Math.max(sy - 48, 8);
                const label = `${Math.round(
                  lineValues[idx] * 1000
                ).toLocaleString("en-US")} ألف مشترك`;
                return (
                  <g>
                    <line
                      x1={sx}
                      y1={chart.padTop}
                      x2={sx}
                      y2={chart.padTop + chart.h}
                      stroke="#e5e7eb"
                      strokeDasharray="2 4"
                    />
                    <circle
                      cx={sx}
                      cy={sy}
                      r="3.5"
                      fill="#1f2937"
                      stroke="#dc2626"
                      strokeWidth="1"
                    />
                    <g>
                      <rect
                        x={bx}
                        y={by}
                        rx="10"
                        ry="10"
                        width="180"
                        height="34"
                        fill="#ffffff"
                        stroke="#dc2626"
                      />
                      <text
                        x={bx + 90}
                        y={by + 22}
                        textAnchor="middle"
                        fontSize="12"
                        className="fill-[#dc2626]"
                      >
                        {label}
                      </text>
                    </g>
                  </g>
                );
              })()}
            </svg>
            <div className="grid grid-cols-12 text-xs text-gray-500 mt-2">
              {lineMonths.map((m, i) => (
                <div key={i} className="text-center">
                  {m}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="mt-6 bg-white rounded-xl border border-gray-100 shadow-sm">
        <div className="flex items-center justify-between p-4">
          <h3 className="font-semibold text-[#1D2035]">المشتركين</h3>
          <button className="px-3 py-1.5 text-sm rounded-md border border-gray-200">
            عرض الكل
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-gray-500 bg-[#fafafa]">
                <th className="p-3 text-right font-medium">الاسم</th>
                <th className="p-3 text-right font-medium">القسم</th>
                <th className="p-3 text-right font-medium">رقم الهاتف</th>
                <th className="p-3 text-right font-medium">البلد</th>
                <th className="p-3 text-right font-medium">حالة الاشتراك</th>
                <th className="p-3"></th>
              </tr>
            </thead>
            <tbody>
              {subscribers.map((s, idx) => (
                <tr
                  key={idx}
                  className="border-t border-gray-100 hover:bg-gray-50"
                >
                  <td className="p-3 text-[#1D2035]">{s.name}</td>
                  <td className="p-3">{s.dept}</td>
                  <td className="p-3">{s.phone1}</td>
                  <td className="p-3">{s.phone2}</td>
                  <td className="p-3">
                    <span
                      className={`inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border ${
                        s.status === "فعال"
                          ? "text-green-700 bg-green-50 border-green-200"
                          : "text-amber-700 bg-amber-50 border-amber-200"
                      }`}
                    >
                      <span
                        className={`w-1.5 h-1.5 rounded-full ${
                          s.status === "فعال" ? "bg-green-500" : "bg-amber-500"
                        }`}
                      />
                      {s.status === "فعال" ? "الاشتراك فعال" : "انتهى الاشتراك"}
                    </span>
                  </td>
                  <td className="p-3 text-gray-400">•••</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between p-4 text-sm text-gray-600">
          <div>الصفحة 1 من 90</div>
          <div className="flex items-center gap-2">
            <button className="px-2 py-1 rounded-md border border-gray-200">
              «
            </button>
            {[1, 2, 3].map((n) => (
              <button
                key={n}
                className={`px-2.5 py-1 rounded-md border ${
                  n === 1
                    ? "bg-gray-900 text-white border-gray-900"
                    : "border-gray-200"
                }`}
              >
                {n}
              </button>
            ))}
            <span className="px-2">…</span>
            <button className="px-2.5 py-1 rounded-md border border-gray-200">
              90
            </button>
            <button className="px-2 py-1 rounded-md border border-gray-200">
              »
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
